import classNames from 'classnames';
import { FormattedMessage } from 'react-intl';
import { LOADING_TYPES, Voucher } from '../../../../utils/checkoutState';
import Button from '../../../atoms/Button';
import EllipsisText from '../../../atoms/EllipsisText';
import Price from '../../../atoms/Price';
import './style.scss';

type VoucherListProps = {
  vouchers: Voucher[];
  isLoading: string;
  areGiftCardsEnabled: boolean;
  removeHandler: (id: string) => Promise<void>;
};

const VoucherList = ({ vouchers, isLoading, areGiftCardsEnabled, removeHandler }: VoucherListProps) => (
  <div className={classNames('vouchers', { 'voucher--with-giftcards': areGiftCardsEnabled })}>
    {vouchers.map(({ id, name, discount }) => (
      <div className="vouchers__item" key={id}>
        <div className="content">
          <EllipsisText className="vouchers__item--name" title={name} data-test-id="voucher_item-name">
            {name}
          </EllipsisText>
          <span className="vouchers__item--discount" data-test-id="voucher_item-discount">
            <Price price={discount * -1} />
          </span>
          <Button
            type="button"
            className="vouchers__item--btn"
            onClick={() => removeHandler(id)}
            isLoading={isLoading === LOADING_TYPES.voucherRemove(id)}
            disabled={!!isLoading}
            data-test-id="voucher-remove-btn"
          >
            <FormattedMessage id="generic.remove" />
          </Button>
        </div>
      </div>
    ))}
  </div>
);

export default VoucherList;
